// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1dMVe","colBig":"styles_colBig__JWpSn","colSmall":"styles_colSmall__18jQw"};